import { setupWeb3 } from './web3';
import { getENS } from './ens';
export { utils, ethers } from 'ethers';
export async function setupENS() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      customProvider = _ref.customProvider,
      ensAddress = _ref.ensAddress,
      reloadOnAccountsChange = _ref.reloadOnAccountsChange;

  await setupWeb3({
    customProvider,
    reloadOnAccountsChange
  });
  await getENS(ensAddress);
}
export * from './ens';
export * from './registrar';
export * from './registry';
export * from './web3';
export * from './constants/interfaces';
export * from './constants/tlds';
export * from './utils';